import { useState } from 'react';
import { tags } from '@/mocks/heiliao';

export default function TagSection() {
  const [selected, setSelected] = useState<string[]>(['热播剧', '行业观察']);

  const toggle = (tag: string) => {
    setSelected((prev) => (prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]));
  };

  return (
    <section id="topics" className="w-full bg-secondary-900 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="reveal flex flex-col gap-5 border-b border-secondary-700 pb-6 md:flex-row md:items-end md:justify-between">
          <div className="w-full">
            <span className="text-xs font-semibold tracking-[0.3em] text-accent-400">TAG NAVIGATION</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-background-50 md:text-4xl">标签导航</h2>
          </div>
          <p className="max-w-lg text-sm leading-relaxed text-secondary-200">
            标签导航是"先浏览、再聚焦"。选择你关心的标签，组合出属于自己的检索入口。
          </p>
        </div>

        <div className="reveal mt-8 flex flex-wrap gap-2.5">
          {tags.map((tag) => {
            const isOn = selected.includes(tag);
            return (
              <button
                key={tag}
                type="button"
                onClick={() => toggle(tag)}
                aria-pressed={isOn}
                className={`cursor-pointer whitespace-nowrap rounded-full border px-4 py-2 text-xs font-medium transition-colors md:text-sm ${
                  isOn
                    ? 'border-accent-500 bg-accent-500 text-secondary-950'
                    : 'border-secondary-600 text-secondary-100 hover:border-accent-400 hover:text-accent-400'
                }`}
              >
                #{tag}
              </button>
            );
          })}
        </div>

        <div className="reveal mt-8 flex flex-col gap-4 rounded-lg border border-secondary-700 bg-secondary-950 p-5 md:flex-row md:items-center md:justify-between md:p-6">
          <div>
            <p className="text-xs text-secondary-300">当前已选标签</p>
            <p className="mt-2 flex flex-wrap gap-2">
              {selected.length === 0 ? (
                <span className="text-sm text-secondary-300">尚未选择，点击上方标签开始组合</span>
              ) : (
                selected.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-sm bg-secondary-800 px-2.5 py-1 text-xs text-accent-400"
                  >
                    #{tag}
                  </span>
                ))
              )}
            </p>
          </div>
          <a
            href="#ranking"
            className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-secondary-950 transition-colors hover:bg-accent-400"
          >
            <i className="ri-filter-3-line"></i>
            用标签查看内容
          </a>
        </div>
      </div>
    </section>
  );
}